<template>
    <div class="return-total-summary">
        <section class="summary-section">
            <div class="summary-container">
                <dl>
                    <dt class="paragraph-default">Subtotal</dt>
                    <dd class="paragraph-default">${{ formatPrice(subtotal) }}</dd>
                </dl>

                <dl v-if="couponAdjust">
                    <dt class="paragraph-default">Coupon Adjust</dt>
                    <dd class="paragraph-default">${{  formatPrice(couponAdjust) }}</dd>
                </dl>

                <dl>
                    <dt class="paragraph-default">Estimated Tax</dt>
                    <dd class="">${{  formatPrice(tax) }}</dd>
                </dl>
                <dl class="order-total">
                    <dt class="title-l">Estimated Return Amount</dt>
                    <dd class="title-l">${{ formatPrice(amount) }}</dd>
                </dl>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
    interface ReturnTotal {
        subtotal: number;
        couponAdjust: number;
        tax: number;
        amount: number;
    }

    import { computed, toRefs} from "vue";
    import { formatPrice } from "@/helpers/composables/usePriceFormatting";

    const props = defineProps({
        returnAmount: {
            type: Object as PropType<ReturnTotal>,
            required: true
        }
    })

    const { returnAmount } = toRefs(props);

    const subtotal = computed(()=>{
        return returnAmount.value.subtotal;
    })

    const couponAdjust = computed(()=>{
        return returnAmount.value.couponAdjust;
    })

    const tax = computed(()=>{
        return returnAmount.value.tax;
    })

    const amount = computed(()=>{
        return returnAmount.value.amount;
    })
</script>